<template lang="pug">
	.campaign-stations.flex-col.space-medium
		Loader(v-if="isLoading", text="")
		.flex-row.space.wrap.align-center.center.wrap(v-if="campaign.Stations")
			.station.adt-tag.font-tiny.flex-row.space.align-center(v-for="station in campaign.Stations")
				span {{station.Name}}
				.adt-button.rounded.flex-row.align-center.center.clickable(v-if="!info.readonly", @click="removeStation(station.Oid)")
					fas(icon="times")
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxDateBox from 'devextreme-vue/date-box';
	import Loader from 'app-core/Loader.vue';
	import campaignStations from './campaign-stations.js';

	export default {
		translationCategory: 'campaign.Detail',
		name: 'campaign-stations',
		mixins: [campaignStations],
		components: {
			DxButton, DxTextBox, Loader, DxDateBox
		},
		data() {
			return {
			};
		},
		mounted() {
			if (__DEBUG__)
				window.campaignStations = this;
		},
		methods: {
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.campaign-stations {
		min-height: 280px;

		
	}
</style>
 